<template>
  <div class="top-filters">
    <div :class="{ mb16: showClearBtn }" class="top-filters__header">
      <div class="left">
        <FilterTopComponentsFilterBtn class="filter-btn posr ht hm" />
        <button
            :class="{ 'btn-violet white': !activeFilters.liked && !activeFilters.hided }"
            class="btn btn-primary light fw500 favorite-btn posr"
            @click="activeFilters.liked || activeFilters.hided ? clearAll() : () => null"
        >
          <svg class="mr0 mb2" height="20" width="20">
            <use xlink:href="/icons/sprite.svg#i-globe"></use>
          </svg>
          <span class="ml4 hm ht">
            {{
              t("all_counted_items", {
                n:
                    activeFilters.liked || activeFilters.hided
                        ? 0
                        : allItemsCount?.toLocaleString("ru-RU")
              })
            }}
          </span>
          <!--          <span class="ml4 hd">-->
          <!--            {{ t("ALL") }}-->
          <!--            {{-->
          <!--              activeFilters.liked || activeFilters.hided-->
          <!--                  ? 0-->
          <!--                  : allItemsCount?.toLocaleString("ru-RU")-->
          <!--            }}-->
          <!--          </span>-->
        </button>

        <button
            :class="{ 'btn-violet white': activeFilters.liked }"
            class="btn btn-primary fw500 light favorite-btn"
            @click="setFavorite"
        >
          <svg v-if="!activeFilters.liked" height="20" width="20">
            <use xlink:href="/icons/sprite.svg#i-heart-empty"></use>
          </svg>
          <svg v-else height="20" width="20">
            <use xlink:href="/icons/sprite.svg#i-heart"></use>
          </svg>
          <span class="hm ht">
            {{ t("featured") }}
          </span>
        </button>

        <button
            :class="{ 'btn-violet white': activeFilters.hided }"
            class="btn btn-primary fw500 light favorite-btn"
            @click="setHide"
        >
          <svg height="20" width="20">
            <use xlink:href="/icons/sprite.svg#i-eye-crossed"></use>
          </svg>
          <span class="hm ht">
            {{ t("hidden") }}
          </span>
        </button>

        <button class="btn btn-transparent px10 hd mla light" @click="openSortModal()">
          <svg height="22" width="22">
            <use xlink:href="/icons/sprite.svg#i-sort"></use>
          </svg>
        </button>
        <!--        <SortBy class="hlgt" />-->
        <FilterTopComponentsFilterBtn class="filter-btn posr hd" />
        <button class="btn btn-transparent px12 hd light" @click="showSearch = !showSearch">
          <i class="icon i-search f16"></i>
        </button>
      </div>

      <div class="right hm ht">
        <UiSelect
            v-model="activeFilters.sales_period"
            :items="[SalesPeriod.Weekly, SalesPeriod.Monthly]"
            class="sales-select"
        >
          <template #top-in>
            <span class="f gap4 fw600">
              <span class="gray hm">{{ t("sales") }}:</span>
              <span>
                {{ t("past_days", activeFilters.sales_period === SalesPeriod.Weekly ? 7 : 30) }}
              </span>
            </span>
          </template>
          <template #default-in="{ item, onChange }">
            <span class="f gap4 fw600" @click="onChange">
              <!--              <span class="gray">{{ t('sales') }}: </span>-->
              <span :class="{ white: activeFilters.sales_period !== item }">
                {{ t("past_days", item === SalesPeriod.Weekly ? 7 : 30) }}
              </span>
            </span>
          </template>
        </UiSelect>

        <Search :header="false" class="search-input" />
      </div>

      <Search v-show="showSearch" :header="false" class="search-input w-100" />
    </div>

    <transition-group class="active-filters" name="list" tag="div">
      <button v-if="showClearBtn" class="btn btn-bordered red" @click="clearAll">
        {{ t("clear_all") }}
      </button>

      <button
          v-if="activeFilters.price_from || activeFilters.price_to"
          class="btn btn-bordered"
          @click="clear('price')"
      >
        {{ t("price") }}:

        <span :class="`c-${currencyName}`">{{ activeFilters.price_from }}</span>
        <template v-if="activeFilters.price_to">
          -
          <span :class="`c-${currencyName}`">{{ activeFilters.price_to }}</span>
        </template>
        <i class="i-times"></i>
      </button>

      <button
          v-if="activeFilters.profit_value_from || activeFilters.profit_value_to"
          class="btn btn-bordered"
          @click="clear('profit_value')"
      >
        {{ t("profit_value") }}:
        <span :class="`c-${currencyName}`">{{ activeFilters.profit_value_from }}</span>
        <template v-if="activeFilters.profit_value_to">
          -
          <span :class="`c-${currencyName}`">{{ activeFilters.profit_value_to }}</span>
        </template>
        <i class="i-times"></i>
      </button>

      <button
          v-if="activeFilters.profit_percentage_from || activeFilters.profit_percentage_to"
          class="btn btn-bordered"
          @click="clear('profit_percentage')"
      >
        {{ t("profit_percent") }}:
        <span>%{{ activeFilters.profit_percentage_from }}</span>
        <template v-if="activeFilters.profit_percentage_to">
          -

          <span>%{{ activeFilters.profit_percentage_to }}</span>
        </template>
        <i class="i-times"></i>
      </button>

      <template v-for="item in filtersArray">
        <template v-if="Array.isArray(activeFilters[item]) && activeFilters[item].length">
          <button
              v-for="i in activeFilters[item]"
              :key="i + '-array'"
              class="btn btn-bordered"
              @click="clear(item, i)"
          >
            <span v-if="item === 'categories'">
              {{ t("compare_extra." + i.toLowerCase()) }}
            </span>
            <span v-else-if="item === 'exteriors'">
              {{ t("filters.exterior." + i) }}
            </span>
            <span v-else-if="item === 'rarities'">
              {{ t("filters.rarity." + i) }}
            </span>
            <span v-else-if="item === 'types'">
              {{ t("filters.weapon." + i) }}
            </span>
            <span v-else>
              {{ i }}
            </span>
            <i class="i-times"></i>
          </button>
        </template>
        <button
            v-else-if="!Array.isArray(activeFilters[item]) && activeFilters[item]"
            :key="item + '-string'"
            class="btn btn-bordered"
            @click="clear(item)"
        >
          {{ t(item) }}:
          <span>
            {{ activeFilters[item] }}
          </span>
          <i class="i-times"></i>
        </button>
      </template>

      <button v-if="showPresetBtn" class="btn btn-bordered preset" @click="saveFilters">
        {{ t("save_preset") }}
      </button>
    </transition-group>
  </div>
</template>

<script lang="ts" setup>
import {useComparisonStore} from "~/store/comparison";
import {ComparisonSort, SalesPeriod} from "~/graphql/generated/schema-types";
import Search from "~/components/FilterTop/Components/Search.vue";
import {useModalStore} from "~/store/modal";
import {ModalIds} from "~/types/Modals";
import {computed} from "vue";
import {useStore} from "~/store";
import {deepEqual} from "~/utils/deep-equal";

const props = defineProps<{
  allItemsCount: number;
}>();

const globalStore = useStore();
const currencyName = computed(() => globalStore.currency);
const {t} = useI18n();

const store = useComparisonStore();
const router = useRouter();
const activeFilters = computed(() => store.activeFilters as typeof store.activeFilters);
const localePath = useLocalePath();
const showSearch = ref(false);
const filtersArray: (keyof typeof store.activeFilters)[] = [
  "sales",
  "offers",
  "categories",
  "collections",
  "exteriors",
  "rarities",
  "types"
];

const modalStore = useModalStore();

const clearAll = () => {
  store.activeFilters = {
    ...store.getClearedFilters(),
    markets_to: store.filters.markets?.map((i) => i?.market_name || "") || [],
    markets_from: store.filters.markets?.map((i) => i?.market_name || "") || [],
    hided: false
  };
  store.page = 1;
  store.sort = ComparisonSort.SalesDesc;
  router.replace({query: {}});
};

const setFavorite = () => {
  store.activeFilters = store.activeFilters = {
    ...store.getClearedFilters(),
    markets_to: store.filters.markets?.map((i) => i?.market_name || "") || [],
    markets_from: store.filters.markets?.map((i) => i?.market_name || "") || [],
    liked: true,
    hided: false
  };
  store.page = 1;
  store.sort = ComparisonSort.SalesDesc;
};

const setHide = () => {
  store.activeFilters = store.activeFilters = {
    ...store.getClearedFilters(),
    markets_to: store.filters.markets?.map((i) => i?.market_name || "") || [],
    markets_from: store.filters.markets?.map((i) => i?.market_name || "") || [],
    hided: true
  };
  store.page = 1;
  store.sort = ComparisonSort.SalesDesc;
};

const clear = (name: string, child?: string) => {
  if (name === "price") {
    store.activeFilters.price_from = null;
    store.activeFilters.price_to = null;
    return;
  }
  if (name === "profit_value") {
    store.activeFilters.profit_value_from = null;
    store.activeFilters.profit_value_to = null;
    return;
  }
  if (name === "profit_percentage") {
    store.activeFilters.profit_percentage_from = null;
    store.activeFilters.profit_percentage_to = null;
    return;
  }
  if (name === "sales" || name === "offers") {
    store.activeFilters[name] = null;
    return;
  }
  if (child) {
    // @ts-ignore
    store.activeFilters[name] = store.activeFilters[name]?.filter((i: string) => i !== child);
  }
};

const showClearBtn = computed(() => {
  return [
    ...filtersArray,
    "price_from",
    "price_to",
    "profit_value_from",
    "profit_value_to",
    "profit_percentage_from",
    "profit_percentage_to"
  ].some((key) => {
    if (Array.isArray(activeFilters.value[key as keyof typeof activeFilters.value])) {
      // @ts-ignore
      return activeFilters.value[key].length > 0;
    }
    return !!activeFilters.value[key as keyof typeof activeFilters.value];
  });
});


const showPresetBtn = computed(() => {
  if (!showClearBtn.value) {
    return false
  }
  return store.presets?.every(preset => {
    return !deepEqual(preset.filters, activeFilters.value)
  })
})

const openSortModal = () => {
  modalStore.openModal(ModalIds.COMPARISON_SORT);
};

const saveFilters = () => {
  modalStore.openModal(ModalIds.COMPARISON_PRESET);
};
</script>

<style lang="scss" scoped>
@use "sass:color";

.top-filters {
  &__header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
    transition: margin-bottom 0.3s;
  }

  @media screen and (max-width: 979px) {
    .top-filters__header {
      flex-direction: column;
      gap: 8px;
      max-width: 400px;
      margin: 0 auto;
    }
    .left,
    .right {
      width: 100%;
    }
    .filter-btn {
      color: var(--surfaces-on-surface-variable);
      background: transparent;

      &:hover {
        background: #252930;
        color: var(--surfaces-on-surface-variable);
      }
    }
    .favorite-btn {
      padding: 0 10px;
    }
  }

  @media screen and (max-width: 768px) {
    &:deep(.search_wrap) {
      left: 0;
    }
  }

  .left,
  .right {
    display: flex;
    align-items: center;
    gap: 8px;

    .posr {
      position: relative;
      z-index: 1;
    }
  }
}

.list-enter-active,
.list-leave-active {
  transition: all 0.5s ease;
}

.list-enter-from,
.list-leave-to {
  opacity: 0;
  transform: translateX(30px);
}

.active-filters {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
  max-height: 75px;
  overflow-y: auto;
  @media screen and (max-width: 979px) {
    display: none;
  }
}

.btn-bordered {
  display: inline-flex;
  padding: 5px 8px;
  justify-content: center;
  align-items: center;
  gap: 8px;
  border-radius: 6px;
  border: 1px solid var(--surfaces-outline);
  background: color-mix(in srgb, var(--surfaces-low-container) 96%, white);
  font-size: 14px;
  font-weight: 400;
  color: var(--surfaces-on-surface-variable);

  &.preset {
    color: var(--accent-secondary);
    font-weight: 600;
  }

  &.red {
    color: var(--destructive);
    font-weight: 600;
  }

  &:hover {
    background: color-mix(in srgb, var(--surfaces-low-container) 92%, white);
  }
}
</style>
